import { createClient } from '@supabase/supabase-js';
import type { Database } from '../../shared/database.types';

const configuredUrl = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!configuredUrl || !key) {
  throw new Error('VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY must be set. See .env.example.');
}

// A relative URL (e.g. "/supabase" in development) resolves against the page's
// origin, so the same build works on localhost, a LAN IP, or a tunnel.
const url = new URL(configuredUrl, window.location.origin).toString().replace(/\/$/, '');

export const supabase = createClient<Database>(url, key, {
  auth: {
    flowType: 'pkce',
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
